export const mapTriggerAndEnrollmentChecksToValidationCheckResults = (triggerValidationResults, enrollmentCheckResults) => {
  // If there are multiple valid trigger checks and they all fail, just pick the first one so we don't
  // render duplicate information on the UI. We'll ensure the same failed state is displayed for all cases
  // when this is applicable
  const passedTriggerValidationCheck = triggerValidationResults.find(r => r.enrollmentAllowed);

  // Right now there's only one situation in which we could have multiple trigger validation checks and they all fail.
  // If this is the case, we'll grab the last one, as that allows us to display the most informative trigger content to the
  // user. We may need to revisit this later on if more complicated cases arise, but I thought this was a good compromise.
  // Reference: https://docs.google.com/document/d/10wHtXZeUsvbNtb1MxMvcVJjBaxPK3NWgN4UARbCCjIU/edit#heading=h.n75ku14gj1wj
  const mappedTriggerValidationResults = passedTriggerValidationCheck ? [passedTriggerValidationCheck] : triggerValidationResults.slice(-1);
  const mappedChecks = [...mappedTriggerValidationResults.map(result => ({
    type: 'VALID_TRIGGER_CHECK',
    result
  })), ...enrollmentCheckResults.map(result => ({
    type: 'ENROLLMENT_CHECK',
    result
  }))];
  return {
    passed: mappedChecks.filter(_ => _.result.enrollmentAllowed),
    failed: mappedChecks.filter(_ => !_.result.enrollmentAllowed)
  };
};